import axios from 'axios';

export default class psNews {
    constructor(el) {
        if (!el) {
            return;
        }

        this.el = el;
        this.content = this.el.querySelector('#ps-news-list');
        this.filters = this.el.querySelector('.ps-filter-list');
        this.loader = this.filters && this.filters.querySelector('.ajax-loading');

        this._initNews();
        this._initFiltering();
    }

    _initNews() {

        this.content.addEventListener('click', event => {
            this._toggleNews(event);
            this._linkedNews(event);
        });

        //To access news with keyboard
        this.content.addEventListener('keyup', event => {
            // check if Enter key is pressed
            if (event.keyCode === 13) {
                this._toggleNews(event);
            }
        });
    }

    _initFiltering() {
        this.filters && this.filters.addEventListener('change', event => {
            if (!(event.target.tagName === 'INPUT' && event.target.type === 'checkbox')) {
                return;
            }

            this._toggleLoader(true);

            const form = event.target.closest('form');

            axios.post(form.action, new FormData(form))
                .then(response => {
                    document.getElementById('ps-news-list').innerHTML = response.data;
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    this._toggleLoader(false);
                });
        });
    }

    _toggleLoader(state) {
        this.loader.toggleAttribute('hidden', !state);
    }

    _error(error) {
        const id = (error && error.response && error.response.status === 401) ? 'ps-logged-out' : 'ps-generic-error';
        alert(document.getElementById(id).value);
    }

    _toggleNews(event) {
        const ActiveLink = 'ps-news__link-active';
        const ActiveContent = 'ps-news__active';

        const link = event.target;

        if (!link.classList.contains('ps-news__link')) {
            return;
        }

        const id = link.parentElement.getAttribute('data-id');
        if (!id) {
            return;
        }

        const content = this.content.querySelector('.ps-news__news-block-link[data-id="' + id + '"]');
        if (!content) {
            return;
        }

        // "inaktivera" tidigare nyhet
        const activeLink = this.content.querySelector('.' + ActiveLink);
        const activeContent = this.content.querySelector('.' + ActiveContent);
        activeLink.parentElement.style.background = "transparent";
        activeLink && activeLink.classList.remove(ActiveLink);
        activeContent && activeContent.classList.remove(ActiveContent);

        // "aktivera" vald nyhet
        content.classList.add(ActiveContent);
        link.classList.add(ActiveLink);
        link.parentElement.style.background = "#fff";
    }
    _linkedNews(event) {
        document.querySelector(".standard-block__link.ps-news__news-block-link.ps-news__active").addEventListener("click", function () {
            window.location = this.querySelector("a").href;
            return false;
        })
    }
}
